<script lang="ts">
	import { format } from 'svelte-i18n';
	// Stores
	import { devices } from 'src/stores/lists/devices';
	import { devices_config } from '@devices/index';
	// Components
	import EmptyDeviceTypeList from '../../Lists/EmptyDeviceTypeList.svelte';
	// Design system components
	import { Alert, ControlsContainer, Toggle, CardGrid } from '@Shelly/shelly-design-system';
	// Types
	import type { Device } from 'src/types/Device';
	import EnergyDistributionCard from './EnergyDistributionCard.svelte';
	import RealTimeConsumptionGauge from '../TotalCurrentConsumption.svelte';
	import { consumption_by_device_account } from 'src/stores/features/consumption';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import EmptyPlaceholder from 'src/components/EmptyPlaceholder.svelte';

	let showBattery = true,
		consumableDevices = Object.values($devices).filter(
			(device: Device) => devices_config[device.type]?.isPM && !device.shared,
		);

	let gridColsCount;
</script>

<Alert
	class="mb-m"
	type="warning"
	heading={'This functionality is under development and used for testing.'}
	isHeadingBold
	message={'You can see this because you are using a test user account.'}
/>

<!-- {#if Object.values($devices).length === 0}
	<EmptyDeviceList />
	{/if} -->
{#if consumableDevices.length === 0}
	<div class="mt-md-m mt-sm-0 text-center d-flex flex-direction-column">
		<EmptyPlaceholder class="mt-md-l mt-sm-s mb-m" />
		<EmptyDeviceTypeList />
	</div>
{:else}
	<CardGrid lg={350} sm={270} class="mt-m" calcGridCols bind:gridColsCount>
		<ControlsContainer orientation="vertical" color={$showNewLayout ? 'color-1' : undefined}>
			<svelte:fragment slot="first">
				<EnergyDistributionCard {showBattery} />
			</svelte:fragment>
			<svelte:fragment slot="second">
				<Toggle
					bind:checked={showBattery}
					class="mb-s"
					size="m"
					id="toggle-battery-distribution"
				>
					{$format('show_battery_distribution', {
						default: 'Show battery distribution',
					})}
				</Toggle>
			</svelte:fragment>
		</ControlsContainer>

		<RealTimeConsumptionGauge accountConsumptionByDevices={$consumption_by_device_account} />
	</CardGrid>
{/if}
